import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { Formik } from 'formik'

import ValidationSchema from './Form/ValidationSchema'
import ClientInformationStep from './ClientInformationStep'
import CurrentCoverageStep from './CurrentCoverageStep'
import OccupationStep from './OccupationStep'
import IncomeStep from './IncomeStep'
import InsuredAssetsStep from './InsuredAssetsStep'
import IncomeProtectionAnalysisStep from './IncomeProtectionAnalysisStep'
import FormNavigationDots from './FormNavigationDots'

const ManageClient = ({ clientId, formState, onSubmit, onSave }) => (
    <Formik
        initialValues={formState}
        enableReinitialize
        // validate={Validate}
        onSubmit={onSubmit}
        validationSchema={ValidationSchema}
    >
        {(props) => {
            const { handleSubmit, values, isValid } = props

            return (
                <>
                    {onSubmit && (
                        <div>
                            <button
                                style={{ marginTop: '-44px', position: 'relative' }}
                                type="button"
                                onClick={() => {
                                    if (isValid) {
                                        onSubmit(values)
                                    }
                                }}
                                className={
                                    isValid
                                        ? 'btn arrow-btn btn-right'
                                        : 'btn btn-disabled arrow-btn btn-right'
                                }
                            >
                                PRESENT IPSA
                            </button>
                        </div>
                    )}
                    <ul id="graph-nav-status">
                        <FormNavigationDots />
                    </ul>

                    <form onSubmit={handleSubmit} className="hidden-labels">
                        <Switch>
                            {/* NEW Client */}
                            <Redirect from="/clients/:state" exact to="/clients/:state/client" />
                            <Route
                                path="/clients/:state/client"
                                render={() => (
                                    <ClientInformationStep clientId={clientId} onSave={onSave} />
                                )}
                            />

                            <Route
                                path="/clients/:state/coverage"
                                render={() => (
                                    <CurrentCoverageStep clientId={clientId} onSave={onSave} />
                                )}
                            />
                            <Route
                                path="/clients/:state/assets"
                                render={() => (
                                    <InsuredAssetsStep clientId={clientId} onSave={onSave} />
                                )}
                            />
                            <Route
                                path="/clients/:state/protections"
                                render={() => (
                                    <IncomeProtectionAnalysisStep
                                        clientId={clientId}
                                        onSave={onSave}
                                    />
                                )}
                            />
                        </Switch>
                        {/* <DisplayFormikState {...props} /> */}
                    </form>
                </>
            )
        }}
    </Formik>
)

export default ManageClient

// export const DisplayFormikState = props => (
//     <div style={{ margin: '1rem 0', width: '35%' }}>
//         <h3 style={{ fontFamily: 'monospace' }}>Formik State</h3>
//         <pre
//             style={{
//                 fontSize: '1rem',
//                 padding: '.5rem'
//             }}
//         >
//             <strong>props</strong> = {JSON.stringify(props, null, 2)}
//         </pre>
//     </div>
// )
